import { GeometryType } from '../../geometry/GeometryType'
import { resolveImportedBrepGeometryObjectAssetScope } from './imported-brep-geometry-object-id'

/**
 * 判断几何对象是否为导入 BRep hydration 注册的基线实体。
 *
 * 设计说明：
 * 1. BRep baseline solid 是 Worker 侧为了 STEP 导出与内核拓扑操作保留的权威 Shape；
 * 2. 导入模型在设计树中的实体节点应只由 GLB hierarchy 投影，避免同一物理实体被 Worker 与 GLB 双轨展示；
 * 3. 该判定收口在 cad-core，web-client 只消费语义能力，不直接依赖散落的 metadata 字段。
 *
 * @param object 待判断的几何对象。
 * @returns 是否为导入 BRep 基线实体。
 */
export function isImportedBaselineSolid(object: GeometryObject): boolean {
  return object.type === GeometryType.SOLID && object.metadata?.isImportedBaseline === true
}

/**
 * 判断几何对象是否为 Feature 时间线之前的原始导入 BRep 基线。
 *
 * 设计说明：
 * 1. `isImportedBaseline` 只说明对象来自离线/导入 BRep 注册，不足以区分原始导入体与 Feature 最终快照；
 * 2. 原始导入体必须同时具有合法的 imported-brep 身份，避免按任意字符串前缀猜测来源；
 * 3. 携带 `commandId` 的基线由 Feature 产出，只能用于完整历史末端的降级显示，禁止注入较早 replay 位置。
 *
 * @param object 待判断的几何对象。
 * @returns 是否为可以作为零件 Feature replay 起点的原始导入 BRep 基线。
 */
export function isOriginalImportedBrepBaseline(object: GeometryObject): boolean {
  const commandId = typeof object.commandId === 'string' ? object.commandId.trim() : ''
  return isImportedBaselineSolid(object)
    && commandId.length === 0
    && resolveImportedBrepGeometryObjectAssetScope(object.id) !== null
}
